export default __webpack_public_path__ + "static/media/floor5.8b66a0cb.svg";